module.exports = __webpack_public_path__ + "dbfc37bba72a55d349a4a5b635a7915b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner-image.jpg
// module id = 108
// module chunks = 0